/* istanbul ignore file */
/* TODO: Refactor directory structure */
/* FIXME: Add unit tests */
export type CustomEventUnsubscribe = () => void;

export abstract class CustomEmitter<
  CustomEventType,
  CustomEventData = Record<string, unknown>,
  CustomEvent extends {
    type: CustomEventType;
  } = {
    type: CustomEventType;
    data?: CustomEventData;
  },
> {
  private readonly listeners: Set<{
    events: CustomEventType[] | '*';
    callback: (event: CustomEvent) => unknown;
  }> = new Set();

  on(
    events: CustomEventType[] | '*',
    callback: (event: CustomEvent) => unknown,
  ): CustomEventUnsubscribe {
    const listener = { events, callback };
    this.listeners.add(listener);

    return () => {
      this.listeners.delete(listener);
    };
  }

  protected fire(events: CustomEvent[]): void {
    setTimeout(() => {
      for (const event of events) {
        for (const listener of this.listeners) {
          if (listener.events === '*' || listener.events.includes(event.type)) {
            listener.callback(event);
          }
        }
      }
    });
  }
}
